import ChartPDFParametersFormattingStrategy from './ChartPDFParametersFormattingStrategy'
import ChartPDFDateRangeFormattingStrategy from '../../../../pdf/formatters/ChartPDFDateRangeFormattingStrategy'

export default class ChartPDFWorkingHoursCostBillingParametersFormattingStrategy extends ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
        super.init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor)
        return this
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        return {
            firstRow:  this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
            secondRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFWorkingHoursCostBillingParametersFormattingStrategy.js